// extracted by mini-css-extract-plugin
export default {"VideoToolbar":"_VideoToolbar--zjNV7"};